import axios from 'axios';
import { toast } from 'react-toastify';

export const BASE_URL = import.meta.env.VITE_BASE_URL;

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    return handleResponse(response);
  },
  (error) => {
    // Unreachable server / network error
    if (error?.response?.data == null) {
        const fallbackMessage = error.message || "Network error. Please try again later.";
        toast.error(fallbackMessage);
        return Promise.reject(error);
    }
    return handleResponse(error?.response);
  }
);

const handleResponse = (response) => {
    // If the response is success:false, treat it as an error
    if (response?.data?.success === false) {
      const { code = 400 } = response.data;

      const isAuthRequest = response?.config?.url?.includes("/login");
      // Handle 401 separately
      if ((code === 401) && !isAuthRequest) {
        localStorage.clear();
        toast.error("Session expired. Please log in again.");
        setTimeout(() => window.location.href = "/login", 3500);
      }

      // Reject manually to ensure .catch() in caller works
      return Promise.reject(response.data);
    }

    return response.data;
}

export const apiWrapper = async (apiCall, showToast = true, show_ve = false, get_blob = false) => {
  try {
    const response = await apiCall();
    if (!get_blob) {
      if (![200, 201, 204].includes(response.code)) {
        return [response.data || response.errors , null]
      }
      return [null, response.data];
    } else {
      return response;
    }
  } catch (error) {
    const message = error?.message || "Something went wrong.";
    if (showToast) {
      if (message == 'Validation error') {
        if (show_ve) {
          toast.error(message);
        }
      } else {
        toast.error(message);
      }
    }
    return [error.errors || {}, null];
  }
}

export default api;
